// import {} from

export const parseUTMTags = () => {
    const params = new URLSearchParams(window.location.search);

    const utm_medium = params.get('utm_medium') || undefined;
    const utm_source = params.get('utm_source') || undefined;
    const utm_campaign = params.get('utm_campaign') || undefined;
    const utm_content = params.get('utm_content') || undefined;
    const utm_term = params.get('utm_term') || undefined;

    return {
        utm_medium,
        utm_source,
        utm_campaign,
        utm_content,
        utm_term,
    };
};

export const convertToMetafieldInput = (utm = {}) => {
    return Object.entries(utm)
        .map(([key, value]) => {
            return {
                key,
                value,
            };
        })
        .filter((item) => item.value !== undefined);
};

export const appendUTMToUrl = (url, utm = {}) => {
    const obj = { ...utm };
    Object.keys(obj).forEach((key) => {
        if (obj[key] === undefined) {
            delete obj[key];
        }
    });

    const params = new URLSearchParams(obj);

    const str = params.toString();
    if (str) {
        return url + '&' + str;
    } else {
        return url;
    }
};
